import React from 'react';
import PropTypes from 'prop-types';
import { UiCheckbox, UiFormControlLabel } from 'ui-components';
import { translate } from 'utils';

export function FilterSubCategoryList(props) {
  const {
    subCategories = [],
    category,
    onSubCategoryChange,
    selectedCategories,
    disabled,
  } = props;

  const handleSubCategoryChange = (event, category) => {
    onSubCategoryChange(event, category);
  };

  return (
    <>
      {subCategories.map((subCategory) => {
        return (
          <div key={subCategory} className='sub-category flex pr-20'>
            <UiFormControlLabel
              className='mr-0'
              label={translate[subCategory]}
              data-testid={`filter-content-sub-category-${`${category}_${subCategory}`}-label`}
              control={
                <UiCheckbox
                  name={subCategory}
                  onChange={(event) => handleSubCategoryChange(event, category)}
                  checked={Boolean(
                    selectedCategories[category]?.includes(subCategory)
                  )}
                  inputProps={{
                    'data-testid': `filter-content-sub-category-${`${category}_${subCategory}`}-checkbox`,
                  }}
                  disabled={disabled}
                />
              }
            />
          </div>
        );
      })}
    </>
  );
}

FilterSubCategoryList.propTypes = {
  subCategories: PropTypes.array,
  category: PropTypes.string,
  onSubCategoryChange: PropTypes.func,
  selectedCategories: PropTypes.object,
  disabled: PropTypes.bool,
};
